module.exports = __webpack_public_path__ + "static/media/creditOption-books.b04fa16d.svg";